import React from "react";
import { connect } from "react-redux";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  Icon,
  Modal,
  Select,
  Input
} from "../../components";
import { axios, Globals, Colors, Constants, SocketEvents } from "../../utils";
import { User as Users, Sidebar } from "../../services";
import CreateEditSeller from "./create_edit_seller";
import ViewSeller from "./view_seller";
import AddIcon from '../../assets/icons/add.png';
import globals from "../../utils/globals";
import socket from '../../utils/socket';

class Sellers extends React.Component {
  constructor(props) {
    super(props);

    const countryEquivalent = globals.getUserCountryEquivalent();

    this.state = {
      header: [
        "Nombre/Razón social",
        "Correo electrónico",
        countryEquivalent.bothDni,
        "Teléfono",
        "Comisión",
        //"Rol",
        //"Estatus",
        "Acciones"
      ],
      page: 1,
      last_page: 1,
      data: [],
      user: null,
      view: false,
      list_status_seller: [
        { value: "", label: "Todos" },
        { value: 1, label: "Activos" },
        { value: 0, label: "Inactivos" }
      ],
      form: {
        status_seller: null,
        search: null,
        user_id: this.props.user.id,
        role: this.props.user.role,
        admin_id: this.props.user.level_id === Constants.ROLE_ADMIN ? this.props.user.id : this.props.user.admin_id,
        web: true,
      },
      permissions: [],
      countryEquivalent,
    };
  }

  abortController = new AbortController()

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    this.abortController.abort()
    if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
  }

  load = () => {
    Globals.setLoading();
    let param = this.state.form;
    param.role = this.props.user.role;
    if (this.props.user.role === 3) {
      param.user_id = this.props.user.id;
    }
    if (this.props.user.role === 4) {
      param.user_id = this.props.user.enterprise_users.enterprise_id;
    }
    param.web = true
    param.user_id = this.props.user.id
    axios
      .post("web/admin/sellers?page=" + this.state.page, param)
      .then(res => {
        if (res.data.sellers) {
          this.setState({
            last_page: res.data.sellers.last_page,
            data: res.data.sellers.data,
            //retentions: res.data.retentions,
            //enterprises: res.data.enterprises
          });
        }
      })
      .catch(err => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });

    this.getPermissions()

  };

  getStatus = status => {
    let respuesta = "";
    switch (status) {
      case 0:
        respuesta = {
          text: "Inactivo",
          color: Colors.red
        };
        break;

      case 1:
        respuesta = {
          text: "Activo",
          color: Colors.green
        };
        break;

      case 2:
        respuesta = {
          text: "Suspendido",
          color: Colors.orange
        };
        break;
      default:
        break;
    }
    return respuesta;
  };

  getPermissions = () => {
    axios
      .post("admin/sellers/permissions", {})
      .then(res => {
        this.setState({
          permissions: res.data,
        });
      })
      .catch(err => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  }

  close = () => {
    this.setState({
      create: false,
      view: false,
      edit: null,
      user: null
    });

    this.load();
  };

  inactiveUser = Item => {
    const name = Item.name;

    Globals.confirm(`¿Desea inactivar a: ${name}?`, () => {
      Users.setStatusInactive({ id: Item.id })
        .then(response => {
          // socket.emit('disable-user',{id: item.id});
          this.load();
          Globals.showSuccess("¡Vendedor inactivado exitosamente!");
        })
        .catch(error => {
          Globals.showError(error);
        });
    });
  };

  activateUser = Item => {
    const name = Item.name;

    Globals.confirm(`¿Desea activar a: ${name}?`, () => {
      Users.setStatusActive({ Id: Item.id })
        .then(response => {
          //socket.emit('activate-user', { id: item.id });
          this.load();
          Globals.showSuccess("¡Vendedor activado exitosamente!");
        })
        .catch(error => {
          Globals.showError();
        });
    });
  };

  verifyUser = Item => {
    const { person } = Item;
    const name = person.first_name;

    Globals.confirm(`¿Desea verificar a: ${name}?`, () => {
      Users.setStatusVerify({ Id: Item.id })
        .then(response => {
          this.load();
          Globals.showSuccess("¡Vendedor verificado exitosamente!");
        })
        .catch(error => {
          Globals.showError();
        });
    });
  };

  delete = (item, i) => {
    Globals.confirm("¿Desea inhabilitar a: " + item.name + "?", () => {
      Globals.setLoading("Guardando...");
      axios
        .post(`web/admin/sellers/delete/${item.id}`, { id: item.id })
        .then(res => {
          Globals.showSuccess('Vendedor inhabilitado');
          this.load();
        })
        .catch(err => {
          Globals.showError(err.response.data.msg);
        })
        .then(() => {
          Globals.quitLoading();
        });
    });
  };

  handleChange = emitter => {
    const { name, value, type } = emitter.target;
    const isText = !['select-one', 'select-multiple', 'checkbox', 'radio'].includes(type);
    this.setState(
      state => ({ form: { ...state.form, [name]: value } }),
      () => this.autoFilter(isText)
    );
  };

  autoFilter = (isText = false) => {
    if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
    if (isText) {
      const t = setTimeout(() => {
        this.setState({ page: 1 }, () => this.load());
      }, 700);
      this.setState({ searchTimeout: t });
    } else {
      this.setState({ page: 1 }, () => this.load());
    }
  };

  set = (item, i) => {
    Globals.confirm(
      "¿Desea seleccionar al Vendedor multiempresa: " + item.person.first_name + "?",
      () => {
        Globals.setLoading("Guardando...");
        axios
          .post("admin/users/get-user-data", { id: item.id })
          .then(res => {
            this.props.dispatch({
              type: "SET_USER",
              payload: res.data.user
            });
            Sidebar.getModules(res.data.user.role).then(response => {
              this.props.dispatch({
                type: "SET_SIDEBAR",
                payload: response
              });
              this.props.history.push("/enterprises");
            });
          })
          .catch(err => {
            Globals.showError(err.response.data.msg);
          })
          .then(() => {
            Globals.quitLoading();
          });
      }
    );
  };

  changeStatusSeller = item => {
    let message = '';
    const isActive = item.status_seller === Constants.STATUS_ACTIVE;
    message = !!isActive
      ? `¿Deseas desactivar a ${item.name}? No podrá registrar pedidos mientras permanezca inactivo.`
      : `¿Deseas activar a ${item.name}? podrá registrar pedidos nuevamente.`;

    Globals.confirm(message, () => {
      Globals.setLoading("Guardando...");
      axios
        .post("web/admin/sellers/change-status", { seller_id: item.id })
        .then(res => {
          socket.emit(SocketEvents.USERS.UPDATE,{ id: item.id });
          Globals.showSuccess(res.data.msg);
          this.load();
        })
        .catch(err => Globals.showError(err.response.data.msg))
        .then(() => Globals.quitLoading());
    });
  };

  render() {
    const { history } = this.props
    const { create, data, edit, header, list_status_seller, search, status_seller, user, permissions, view } = this.state
    // const titleTable = this.props.user.role === 1 ? 'Multiempresas' : 'Vendedores';
    // const userTypeText = this.props.user.role === 1 ? 'Multiempresa' : 'Vendedor';
    const titleTable = 'Vendedores';
    const userTypeText = 'Vendedor';
    return (
      <Menu history={history}>
        {view && (
          <Modal title={`Ver ${userTypeText}`} onClose={this.close} visible>
            <ViewSeller user={user} />
          </Modal>
        )}

        {create && (
          <Modal
            title={edit ? `Editar ${userTypeText}` : `Nuevo ${userTypeText}`}
            onClose={this.close}
            visible
          >
            <CreateEditSeller edit={edit} onClose={this.close} permissions={permissions} />
          </Modal>
        )}

        <div id="home">
          <div className="row">
            <div className="col-md-6 col-lg-5">
              <Input
                color=" "
                name="search"
                label="Búsqueda"
                className="filter"
                onChange={this.handleChange}
                value={this.state.form.search ?? ""}
                placeholder={"Buscar por Nombre, Email o " + this.state.countryEquivalent.naturalDni}
              />
            </div>
            <div className="col-md-6 col-lg-5">
              <Select
                color="white"
                name="status_seller"
                label="Estatus"
                className="filter"
                defaultname="Seleccione"
                onChange={this.handleChange}
                value={this.state.form.status_seller ?? ""}
                options={list_status_seller.map(i => {
                  return {
                    value: i.value,
                    label: i.label
                  };
                })}
              />
            </div>
          </div>
          <Table
            data={data.length}
            title={titleTable}
            header={header}
            right={
              <Button
                title="Agregar Vendedor"
                small="true"
                onClick={() => {
                  this.setState({
                    create: true
                  });
                }}
              >
                <img src={AddIcon} alt="Agregar Vendedor" />
              </Button>
            }
          >
            {data.map((Item, index) => {
              return (
                <tr key={index}>
                  <td>{Item.name}</td>
                  <td>{Item.email}</td>
                  <td>{Item.document}</td>
                  <td>{Item.phone}</td>
                  <td>{Item.commission}</td>
                  {/* <td>
                    {Globals.getLevel(Item.level_id)}
                  </td> */}
                  {/* <td style={{ color: this.getStatus(Item.status).color }}>
                    {this.getStatus(Item.status).text}
                  </td> */}
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>

                      <Button
                        title="Ver"
                        small="true"
                        color="primary"
                        onClick={() => {
                          this.setState({
                            user: Item,
                            view: true
                          });
                        }}
                      >
                        <Icon name="eye" />
                      </Button>
                      <Button
                        title="Editar"
                        small="true"
                        color=" "
                        style={{ backgroundColor: '#0f54e0' }}
                        onClick={() =>
                          this.setState(
                            {
                              edit: {
                                element: Item,
                                index: index
                              }
                            },
                            () => {
                              this.setState({ create: true });
                            }
                          )
                        }
                      >
                        <Icon name="edit" />
                      </Button>

                      {Item.status === Constants.STATUS_INACTIVE && (
                        <Button
                          color="info"
                          title="Activar"
                          small="true"
                          onClick={() => {
                            this.activateUser(Item);
                          }}
                        >
                          <Icon name="check" />
                        </Button>
                      )}

                      <Button
                        color="red"
                        title="Inhabilitar"
                        small="true"
                        onClick={() => this.delete(Item, index)}
                      >
                        <Icon name="trash" />
                      </Button>
                      {this.props.user.role === 1 && (
                        <Button
                          color="blue"
                          title="Tomar Datos"
                          small="true"
                          onClick={() => this.set(Item, index)}
                        >
                          <Icon name="user" />
                        </Button>
                      )}

                      <style>
                        {`
                                                .custom-toggle-switch {
                                                  position: relative;
                                                  display: inline-block;
                                                  width: 44px;
                                                  height: 24px;
                                                  margin: 0; /* Aseguramos que no tenga márgenes extra que deformen la fila */
                                                }
                                                .custom-toggle-switch input {
                                                  opacity: 0;
                                                  width: 0;
                                                  height: 0;
                                                }
                                                .toggle-slider {
                                                  position: absolute;
                                                  cursor: pointer;
                                                  top: 0; left: 0; right: 0; bottom: 0;
                                                  background-color: #ccc;
                                                  transition: 0.3s ease-in-out;
                                                  border-radius: 24px;
                                                }
                                                .toggle-slider:before {
                                                  position: absolute;
                                                  content: "";
                                                  height: 18px;
                                                  width: 18px;
                                                  left: 3px;
                                                  bottom: 3px;
                                                  background-color: white;
                                                  transition: 0.3s ease-in-out;
                                                  border-radius: 50%;
                                                  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                                                }
                                                .custom-toggle-switch input:checked + .toggle-slider {
                                                  background-color: #4cd964;
                                                }
                                                .custom-toggle-switch input:checked + .toggle-slider:before {
                                                  transform: translateX(20px);
                                                }
                                                .custom-toggle-switch input:focus-visible + .toggle-slider {
                                                  outline: 2px solid #005fcc;
                                                  outline-offset: 2px;
                                                }
                                              `}
                      </style>

                      <label
                        className="custom-toggle-switch"
                        title={Item.status_seller === Constants.STATUS_ACTIVE ? "Desactivar" : "Activar"}
                      >
                        <input
                          type="checkbox"
                          checked={Item.status_seller === Constants.STATUS_ACTIVE}
                          onChange={() => this.changeStatusSeller(Item, index)}
                          aria-label={`Cambiar estado de ${Item.name || 'este cliente'}`}
                          aria-checked={Item.status_seller === Constants.STATUS_ACTIVE}
                        />
                        <span className="toggle-slider"></span>
                      </label>

                    </div>
                    
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={page => {
              this.setState(
                {
                  page: page
                },
                () => this.load()
              );
            }}
          />
        </div>
      </Menu>
    );
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(Sellers);
